import http from '@/http'

const PATH = '/invoices'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listInvoices (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{invoiceId: number}} data
     * @returns {Promise<void>}
     */
    async showInvoice (data) {
        try {
            const response = await http.get(`${PATH}/${data.invoiceId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
